import { isEmpty } from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import InsightsContext from '../context/InsightsContext';
import {
  ArrowDown,
  Container,
  Label,
  OptionContainer,
  Option,
  Select,
  Wrapper,
  Tab,
  SelectWrapper,
  ContainerWrapper,
} from './styles/InsightsPaginatedFilterBar.styled';

export default function InsightsPaginatedFilterBar({ filterOptions, industryOptions, dir }) {
  const {
    selectedFilter,
    setSelectedFilter,
    selectedIndustry,
    setSelectedIndustry,
    selectedTag,
    setSelectedTag,
    setSearchValue,
  } = useContext(InsightsContext);
  const [toggleFilter, setToggleFilter] = useState(false);
  const [toggleByIndustry, setToggleByIndustry] = useState(false);
  const filterByRef = useRef(null);
  const byIndustryRef = useRef(null);

  const filterValues = isEmpty(filterOptions)
    ? ['Most Recent', 'Most Popular', 'Trending Topics', 'Business Hub']
    : filterOptions;

  useEffect(() => {
    setSelectedFilter('');
    setSelectedIndustry(industryOptions[0]);
    setSelectedTag('');
    setSearchValue('');
  }, []);

  useEffect(() => {
    const handleClick = (e) => {
      if (filterByRef.current && toggleFilter && !filterByRef.current.contains(e.target)) {
        setToggleFilter(false);
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [toggleFilter]);

  useEffect(() => {
    const handleClick = (e) => {
      if (byIndustryRef.current && toggleByIndustry && !byIndustryRef.current.contains(e.target)) {
        setToggleByIndustry(false);
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [toggleByIndustry]);

  useEffect(() => {
    setToggleFilter(false);
    setToggleByIndustry(false);
  }, [selectedFilter, selectedIndustry, selectedTag]);

  const handleClear = () => {
    setSelectedFilter('');
    setSelectedIndustry(industryOptions[0]);
    setSelectedTag('');
    setSearchValue('');
  };

  return (
    <Wrapper id="insightsFilterBar">
      <Container className="filter-by">
        <Select toggle={toggleFilter} onClick={() => setToggleFilter(true)} dir={dir}>
          <Label dir="dir">{selectedFilter}</Label>
          <ArrowDown />
          <OptionContainer ref={filterByRef} toggle={toggleFilter} className="industry_option">
            {filterValues.map((option) => (
              <Option
                selected={selectedFilter === option}
                onClick={() => {
                  setSearchValue('');
                  setSelectedFilter(option);
                }}
              >
                {option}
              </Option>
            ))}
          </OptionContainer>
        </Select>
      </Container>
      <ContainerWrapper>
        <Container className="by_industry">
          {filterValues.map((option) => (
            <Tab
              selected={selectedFilter === option}
              onClick={() => {
                setSearchValue('');
                setSelectedFilter(option);
              }}
            >
              {option}
            </Tab>
          ))}
          <Select
            toggle={toggleByIndustry}
            onClick={() => setToggleByIndustry(true)}
            className="industry_select"
            dir={dir}
          >
            <SelectWrapper className="industry_select_wrapper">
              <Label dir="dir">{selectedIndustry}</Label>
              <ArrowDown />
            </SelectWrapper>
            <OptionContainer
              ref={byIndustryRef}
              toggle={toggleByIndustry}
              className="industry_option"
            >
              {industryOptions.map((option) => (
                <Option
                  selected={selectedIndustry === option}
                  onClick={() => {
                    setSearchValue('');
                    setSelectedIndustry(option);
                  }}
                >
                  {option}
                </Option>
              ))}
            </OptionContainer>
          </Select>
          <Tab onClick={handleClear}>Clear</Tab>
        </Container>
      </ContainerWrapper>
    </Wrapper>
  );
}
